import React, { forwardRef } from 'react';
import { styled } from '@compiled/react';
import { LinkItem as AkLinkItem, CustomItem } from '@atlaskit/menu';
import type { LinkItemProps } from '@atlassian/jira-navigation-types/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { WithUnwrappedInteractiveChildren } from '../interactive-item/index.tsx';
import { useNavigate } from './utils/navigate/main.tsx';

export const LinkItem = forwardRef<HTMLAnchorElement, LinkItemProps>(
	({ href, target, onClick, ...rest }, ref) => {
		const Item = fg('jfp-a11y-team_interactive-elements-nesting') ? CustomItem : LinkComponent;
		const navigate = useNavigate({ href, onClick, target });

		return (
			<Item
				{...(fg('jfp-a11y-team_interactive-elements-nesting') && {
					component: WithUnwrappedInteractiveChildren(AkLinkItem),
				})}
				href={href}
				target={target}
				rel={target === '_blank' ? 'noopener noreferrer' : ''}
				onClick={navigate}
				ref={ref}
				{...rest}
			/>
		);
	},
);

// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LinkComponent = styled(AkLinkItem)({
	'&:focus, &:hover, &:active': {
		color: 'inherit',
		textDecoration: 'inherit',
	},
});
